import React from 'react';

export const PinIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect x="-6.10352e-05" width="32" height="32" rx="16" fill="black" fillOpacity="0.04" />
    <path
      d="M16 7.66667C12.775 7.66667 10.1666 10.275 10.1666 13.5C10.1666 17.875 16 24.3333 16 24.3333C16 24.3333 21.8333 17.875 21.8333 13.5C21.8333 10.275 19.225 7.66667 16 7.66667ZM16 15.5833C14.85 15.5833 13.9166 14.65 13.9166 13.5C13.9166 12.35 14.85 11.4167 16 11.4167C17.15 11.4167 18.0833 12.35 18.0833 13.5C18.0833 14.65 17.15 15.5833 16 15.5833Z"
      fill="#502314"
    />
  </svg>
);
